import { render, staticRenderFns } from "./WtFullPageLoader.vue?vue&type=template&id=658db112&scoped=true&lang=pug&"
import script from "./WtFullPageLoader.vue?vue&type=script&lang=js&"
export * from "./WtFullPageLoader.vue?vue&type=script&lang=js&"
import style0 from "./WtFullPageLoader.vue?vue&type=style&index=0&id=658db112&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658db112",
  null
  
)

export default component.exports